import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import Card from '../components/Card';

const PoojasPage = () => {
  const [poojas, setPoojas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/punditpurohit/poojas`)
      .then((res) => res.json())
      .then((data) => setPoojas(Array.isArray(data) ? data : []))
      .catch((err) => {
        console.error('Unable to load poojas', err);
        setPoojas([]);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="pp-main-container">
      <header className="page-header">
        <motion.h1 initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }}>
          Sacred Poojas
        </motion.h1>
        <p>Book authentic Vedic rituals performed by certified Pundits.</p>
      </header>

      <motion.div
        className="pp-grid"
        initial="hidden"
        animate="show"
        variants={{
          hidden: { opacity: 0 },
          show: { opacity: 1, transition: { staggerChildren: 0.1 } },
        }}
      >
        {loading ? (
          <p>Loading poojas...</p>
        ) : poojas.map((pooja) => (
          <Card key={pooja.id} item={{ ...pooja, type: 'Pooja' }} showAddToCart />
        ))}
      </motion.div>
    </div>
  );
};

export default PoojasPage;
